import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';

/**
 * Returns the bottom spacing (with respect of safe area bottom inset) and style
 * for the floating bar/buttons container (e.g. Customization floating bar, Bag CTAs).
 *
 * @example
 * ```tsx
 * const App = () => {
 *   const { floatingBottomBarSpacing, floatingBottomBarStyle } = useFloatingBottomBarSpacing();
 *
 *   console.log(floatingBottomBarSpacing); // 48
 *   console.log(floatingBottomBarStyle); // { bottom: 48 }
 *
 *   return <View style={floatingBottomBarStyle} />;
 * };
 * ```
 */
export const useFloatingBottomBarSpacing = () => {
  const { bottom: safeAreaBottom } = useSafeAreaInsets();

  const bottomOffset = Platform.select({ android: theme.spacing['4'], default: 0 }); // prettier-ignore
  const floatingBottomBarSpacing = Math.max(safeAreaBottom, theme.spacing['4']) + bottomOffset; // prettier-ignore

  const floatingBottomBarStyle = useStyle(
    () => ({ bottom: floatingBottomBarSpacing }),
    [floatingBottomBarSpacing],
  );

  return {
    floatingBottomBarSpacing,
    floatingBottomBarStyle,
  };
};
